const SectionTitle = ({ children }: { children: React.ReactNode }) => {
  return (
    <h3 className='font-nuinto font-bold text-[30px] sm:text-4xl text-title'>{children}</h3>
  );
};

export default SectionTitle;
